<template>
  <DBox
    :id="'cmp-booking-booking-booking_sidewindow-travel_before'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new_travel')}`"
    @addClick="addTravelClick"
  >
    <div :v-if="booking.travels">
      <TravelList
        :type="'before'"
        :travels="travels"
        :preview_load_travel="preview_load_travelBefore"
        :travelHeaders="travelListHeaders"
        :booking="booking"
        @onTravelChange="onTravelChange"
        @selected="onTravelSelected"
        @delete="onTravelDelete"
        @load_travel="onLoad_travel"
      ></TravelList>

      <!-- <div class="dbox-title-bar--options">
      <img @click="addTravelClick" src="static/icons/add-icon.svg" class="dt-icon v4" alt />
    </div> -->

      <template v-if="travelBeforeModalContainer">
        <v-dialog v-model="travelBeforeModal" persistent width="762">
          <TravelForm
            :calendarDate="booking.cdate.start_date + ''"
            :users="booking.users"
            :user="booking.user"
            :booking="booking"
            @cancelled="onAddTravelCancel"
            @submit="onTravelSubmit"
          />
        </v-dialog>
      </template>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import TravelList from "./travel-list";
import TravelForm from "./travel.form";
import { BookingService } from "../../services/booking-service";

import { TravelListMixin } from "./travel-list-container.mixin.js";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import { filterTravelBefore } from "../../models/travel.model";

export default {
  components: {
    DBox,
    TravelList,
    TravelForm,
  },
  mixins: [TravelListMixin("travel_before"), createModalMixin("travelBefore")],
  props: ["booking", "travelListHeaders", "travels"],
  data: function () {
    return {
      selectedContactTravels: new Set(),
      // travelFormDialog: false,
      // travelFormContainer: false,
      // travelFormMode: 'edit',
      // selectedTravel: null
    };
  },
  computed: {
    preview_load_travelBefore: function () {
      return this.booking?.preview_load_travel?.travel_before || [];
    },
  },
  methods: {
    onLoad_travel(payload) {
      this.$emit("load_travel_from", payload);
    },
    // onMenuClick(value) {
    //   this.$emit("load_travel_from", {
    //     type: "before",
    //     selectedContactTravels: Array.from(this.selectedContactTravels).map(
    //       (e) => this.preview_load_travelBefore.find((f) => f.contact_id == e)
    //     ),
    //   });
    // },

    //MARK: Methods
    // onTravelChange: function({value, name, item}) {
    //   this[ActionTypes.TRAVEL.UPDATE.SINGLE]({value, name, item});
    // },
    // onTravelSelected: function(travel) {
    //   this.travelFormContainer = true;
    //   this.travelFormMode = 'edit';
    //   this.selectedTravel = null;
    //   setTimeout(() => {
    //     this.travelFormDialog = true;
    //     BookingService.findTravelDescription({
    //       calendarDateId: this.calendarDateId,
    //       travelId: travel.travel_id
    //     }).then(res => {
    //       console.log(res);
    //       this.selectedTravel = res.data;
    //     });
    //   }, 0)
    // },
    // onTravelDelete: function(travel) {
    //   this[ActionTypes.TRAVEL.DELETE.SINGLE]({travelId: travel.travel_id});
    // },
    // addTravelClick: function(event) {
    //   this.openAddTravelDialog();
    // },
    // onAddTravelCancel: function(event) {
    //   this.closeAddTravelDialog();
    // },
    // onTravelSubmit: function({
    //   mode,
    //   travel
    // }) {
    //   if (mode === 'add') {
    //     this[ActionTypes.TRAVEL.INSERT.SINGLE]({travel});
    //   } else if (mode === 'edit') {
    //     this[ActionTypes.TRAVEL.SET.SINGLE]({travel})
    //   }
    //   this.closeAddTravelDialog();
    // },
    // openAddTravelDialog: function() {
    //   this.travelFormContainer = true;
    //   this.travelFormMode = 'add';
    //   this.selectedTravel = null;
    //   setTimeout(() => {
    //     this.travelFormDialog = true;
    //   }, 0)
    // },
    // closeAddTravelDialog: function() {
    //   this.travelFormDialog = false;
    //   waitForAnimation(() => {
    //     this.travelFormContainer = false;
    //   })
    // }
  },
};
</script>
